import { of } from 'rxjs';
import {
  catchError,
  exhaustMap,
  map,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import {
  collectRoutines,
  extractPayload,
  ofType,
  routine,
} from '@ardoq/rxbeach';
import { toError } from '@ardoq/common-helpers';
import { logError } from '@ardoq/logging';
import { presentationSlides$ } from 'presentation/slideNavigator/presentationSlides$';
import { slideNavigator$ } from 'presentation/slideNavigator/slideNavigator$';
import { loadedPresentation$ } from 'presentation/streams/loadedPresentation$';
import { slides$ } from 'streams/slides/slides$';
import { toRenderedViewpointViewId } from 'views/environmentals/getViewpointModeSupportedViews';
import {
  exportPresentationToPptx$,
  type PptxExportResult,
} from './exportPresentationToPptx';
import { pptxExportRequested } from './pptxExport$';
import { toRunContext } from './runContext';
import { showPptxExportToast } from './showPptxExportToast';

const handlePptxExportRequested = routine(
  ofType(pptxExportRequested),
  extractPayload(),
  withLatestFrom(
    loadedPresentation$,
    slides$,
    presentationSlides$,
    slideNavigator$
  ),
  map(([{ i18nLocale }, ...viewerState]) => ({
    i18nLocale,
    context: toRunContext(...viewerState, toRenderedViewpointViewId),
  })),
  exhaustMap(({ i18nLocale, context }) =>
    exportPresentationToPptx$({ context, i18nLocale }).pipe(
      catchError((error: unknown) => {
        logError(toError(error), 'Failed to export the presentation to PPTX');
        return of('failed' as const);
      }),
      tap((result: PptxExportResult | 'failed') =>
        showPptxExportToast(result, i18nLocale)
      )
    )
  )
);

export const pptxExportRoutines = collectRoutines(handlePptxExportRequested);
